import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const PageHero = ({ title, product }) => {
  return (
    <Wrapper>
      <div className="section-center">
        <nav className="crumbs" aria-label="Drobečková navigace">
          <Link to="/">Domů</Link>
          <span className="sep">›</span>
          {product && (
            <>
              <Link to="/pronajem-party-stanu-vybaveni">Produkty</Link>
              <span className="sep">›</span>
            </>
          )}
          <span className="current">{title}</span>
        </nav>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  background: var(--clr-cream-warm);
  background-image: radial-gradient(rgba(139, 94, 60, 0.06) 1px, transparent 1px);
  background-size: 6px 6px;
  width: 100%;
  min-height: 10vh;
  padding: 1.5rem 0;
  display: flex;
  align-items: center;
  color: var(--clr-charcoal-2);
  border-bottom: 1px solid var(--clr-divider);
  box-shadow: inset 0 -2px 0 var(--clr-accent);

  .crumbs {
    font-family: var(--ff-body);
    font-size: 0.95rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.4rem;
  }
  .crumbs a {
    color: var(--clr-charcoal-3);
    padding: 0.25rem 0.1rem;
    transition: var(--transition);
  }
  .crumbs a:hover {
    color: var(--clr-accent-dark);
  }
  .sep {
    color: var(--clr-accent);
    font-weight: 700;
  }
  .current {
    color: var(--clr-charcoal-1);
    font-family: var(--ff-display);
    font-weight: 600;
    text-transform: capitalize;
  }
`;

export default PageHero;
